import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props {
  onRegenerate: () => void
}

export const RegenerateButton = ({ onRegenerate }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <Button
      onPress={onRegenerate}
      variant={isSystemRedesignEnabled ? 'tertiary' : 'secondary'}
      size={isSystemRedesignEnabled ? 'sm' : 'xs'}
      fullWidth={!isSystemRedesignEnabled}
      frontIcon={ArrowRefresh2}
    >
      Generate
    </Button>
  )
}
